interface CheckboxProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    className?: string;
}

function Checkbox({ id, label, checked, onChange, className }: CheckboxProps) {
    return (
        <div className="flex items-center gap-2">
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className={`absolute opacity-0 w-0 h-0 peer ${className}`}
            />
            <label
                htmlFor={id}
                className="w-5 h-5 flex items-center justify-center border border-feildBorder rounded-basicRadius cursor-pointer peer-checked:bg-grayCol peer-checked:border-feildBorder peer-focus:ring-2 peer-focus:ring-feildBorder transition-colors"
            >
                {checked && (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="red"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-4 h-4"
                    >
                        <path d="M5 12l5 5L20 7" />
                    </svg>
                )}
            </label>
            <span
                onClick={() => onChange(!checked)}
                className="text-blackCol font-medium text-sm cursor-pointer"
            >
                {label}
            </span>
        </div>
    );
}

export default Checkbox;